import { Dialog } from '@headlessui/react';

const ModalDescription = ({ description }) => <Dialog.Description className="akoconf-text-center akoconf-my-8 akoconf-text-xl md:akoconf-text-2xl akoconf-font-bold">{description}</Dialog.Description>

export default ModalDescription;
